import { render, staticRenderFns } from "./MarchandPage.vue?vue&type=template&id=a5b63cea&"
import script from "./MarchandPage.vue?vue&type=script&lang=js&"
export * from "./MarchandPage.vue?vue&type=script&lang=js&"
import style0 from "./MarchandPage.vue?vue&type=style&index=0&id=a5b63cea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports